{
  "locales": [
    { "code": "en", "name": "English", "english": "English" },
    { "code": "es", "name": "Español", "english": "Spanish" }
  ]
}
